import { createAction } from '@ngrx/store';

export const APP_SET_START = '[APP][SET]::[Start]';

export const SetStart = createAction(APP_SET_START);
